var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormPageBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 998,
    viewBox: "0 0 595 998",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3703_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M760.569 66.9701L474.884 561.792C469.514 571.093 460.671 577.882 450.302 580.665C439.933 583.448 428.887 581.996 419.593 576.631L134.19 411.853C124.913 406.497 113.885 405.048 103.534 407.826C93.1836 410.604 84.3569 417.381 78.9962 426.666L-206.832 921.735C-212.193 931.02 -213.648 942.052 -210.878 952.405C-208.109 962.758 -201.341 971.584 -192.063 976.94L334.692 1281.06C343.969 1286.42 354.996 1287.87 365.347 1285.09C375.698 1282.31 384.525 1275.53 389.885 1266.25L675.606 771.366C678.264 766.763 681.802 762.729 686.018 759.495C690.235 756.261 695.047 753.89 700.179 752.517C705.311 751.144 710.663 750.798 715.928 751.496C721.193 752.195 726.268 753.926 730.862 756.589L1016.26 921.366C1020.88 924.031 1025.98 925.755 1031.26 926.44C1036.55 927.125 1041.91 926.757 1047.06 925.357C1052.2 923.957 1057.02 921.553 1061.23 918.283C1065.44 915.014 1068.97 910.943 1071.6 906.306L1357.29 411.485C1359.95 406.887 1361.69 401.809 1362.39 396.541C1363.09 391.274 1362.75 385.92 1361.38 380.787C1360.01 375.653 1357.64 370.841 1354.41 366.625C1351.18 362.409 1347.15 358.873 1342.55 356.217L815.799 52.0955C811.2 49.4403 806.122 47.7187 800.856 47.0293C795.589 46.3398 790.238 46.6961 785.109 48.0777C779.979 49.4593 775.171 51.839 770.96 55.0808C766.749 58.3225 763.218 62.3627 760.569 66.9701Z",
    fill: "url(#paint0_linear_3703_2257)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3703_2257",
    x1: 333.564,
    y1: 396.683,
    x2: 333.564,
    y2: 721.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11302D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3703_2257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 595,
    height: 998,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPageBg);
export default __webpack_public_path__ + "static/media/formPageBg.f3ead9ec18c077e5bbd25f50be2e29f1.svg";
export { ForwardRef as ReactComponent };